module.exports = __webpack_public_path__ + "img/welcome1.cc6c0a06.svg";